import React from 'react';
import '../styles/ConfirmationModal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSecondary?: () => void;
  title: string;
  message: string;
  confirmText?: string;
  secondaryText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  onSecondary,
  title,
  message,
  confirmText = 'Confirm',
  secondaryText,
  cancelText = 'Cancel',
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
        <div className="confirmation-modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            {cancelText}
          </button>
          {secondaryText && onSecondary && (
            <button className="btn-cancel" onClick={onSecondary}>
              {secondaryText}
            </button>
          )}
          <button className="btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 